import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

const handleDownload = async (csvConfig, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const wb = XLSX.utils.book_new();

  csvConfig.forEach(sheet => {
    const ws = XLSX.utils.aoa_to_sheet(sheet["data"]);
    XLSX.utils.book_append_sheet(wb, ws, sheet["sheetName"]);
  });

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName);
  return true;
};

export { handleDownload };
